/**
 * Склонение слов
 * @example declOfNum(count, ['найдена', 'найдено', 'найдены']);
 * @param {Number} number
 * @param {Array} titles
 * @returns {String} - подходящее слово
 */
export function declOfNum(number, titles) {
  if (number < 1) number = 2;
  else number = Math.ceil(number)
  var cases = [2, 0, 1, 1, 1, 2];
  return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}

export function normalizeLength(number, minLength, fill) {
  if(!fill) {
    fill = '0'
  }

  const diffLength = minLength - number.toString().length;
  if(diffLength > 0) {
    return fill.repeat(diffLength) + number.toString();
  }
  return number;
}

/**
 * Группирование по полю
 * @example
 * const data = [{ name: "Display", group: "Technical detals", id: 60, value: 4 }, { name: "Manufacturer", group: "Manufacturer", id: 58, value: "Apple" }, { name: "OS", group: "Technical detals", id: 37, value: "Apple iOS" }];
 * console.log(groupBy(data, "group"));
 *
 * @param {Array} arr
 * @param {String} prop
 * @returns {Array[][]} -сшруппированый по полю массив массивов
 */
export function groupBy(arr, prop) {
  const map = new Map(Array.from(arr, obj => [obj[prop], []]));
  arr.forEach(obj => map.get(obj[prop]).push(obj));
  return Array.from(map.values());
}

/**
 * Отсортировать массив по другому массиву
 * @param {Array} source
 * @param {String} property
 * @param {Array} sortingArray
 */
export function sortBy(source, property, sortingArray) {
  return source.slice().sort(function(a, b){
    return sortingArray.indexOf(a[property]) - sortingArray.indexOf(b[property]);
  });
}

/**
 * Вернуть объект содержащий только указанные поля.
 *
 * @param object
 * @param keys
 */
export function objectWithKeys(object, keys) {
  let newObj = {};
  for(let key in object) {
    if(keys.indexOf(key) >= 0) {
      newObj[key] = object[key];
    }
  }
  return newObj;
}

export function apiBool(value) {
  return value ? 't' : 'f';
}

export function unique(array, propertyName) {
  return array.filter((e, i) => array.findIndex(a => a[propertyName] === e[propertyName]) === i);
}

export function dayNicifier(date) {
  if (typeof date === 'string' && date.includes('-')) {
    return date.replace(/-/g, '/')
  }
  return date
}

export function getMonday(d) {
  d = new Date(d);
  var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}